export const dateSubstractor = (date: string, substractorDate: string) => {
  const dateToSubtractFrom = new Date(date);
  const subtractor = new Date(substractorDate);

  const differenceMilliseconds = dateToSubtractFrom?.getTime() - subtractor?.getTime();
  const differenceDays = differenceMilliseconds / (1000 * 60 * 60 * 24);

  return differenceDays;
};
